export const ID_CARD_NUMBER_MASK = '0-0000-00000-00-0';
export const PHONE_NUMBER_MASK = '000-000-0000';
export const PHONE_NUMBER_MASK_9_DIGITS = '00-000-0000';

export const DOWNLOADABLE_FILE_TYPES = ['application/pdf'];
export const VIEWABLE_FILE_TYPES = ['image/jpeg', 'image/png'];
